import * as React from "react";
import styles from "./country-situation-table.styles";

const CountrySituationTableHeader: React.FC = () => {
  return (
    <div css={[styles.row, styles.header]}>
      <div>Country</div>
      <div>Total cases</div>
      <div>Total deaths</div>
      <div>Avg new daily</div>
      <div>Signature</div>
    </div>
  );
};

export default CountrySituationTableHeader;
